import type { Article } from '../Data/articles';

/** Match the reader's estimate so discovery and article metadata agree. */
export function estimateReadingMinutes(content: string): number {
    return Math.max(1, Math.ceil(content.trim().split(/\s+/).length / 220));
}

/** The persona article embeds its live theme demo directly in Markdown rendering. */
export function hasLiveDemo(article: Pick<Article, 'slug' | 'demo'>): boolean {
    return Boolean(article.demo) || article.slug === 'persona-driven-ui';
}
